import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TalcColor } from 'src/app/shared';

@Component({
  selector: 'app-talc-color-selector',
  templateUrl: './talc-color-selector.component.html',
  styleUrls: ['./talc-color-selector.component.scss'],
})
export class TalcColorSelectorComponent implements OnInit {
  @Input() talcColors: TalcColor[];
  @Input() disabled = false;
  @Output() talcColorsChange = new EventEmitter();

  @Input('selected') selected?: TalcColor;
  @Output('selectedChange') selectEvent = new EventEmitter<TalcColor>();

  constructor() {}
  ngOnInit(): void {}

  public selectColor(index: number) {
    const selected = this.talcColors[index];
    this.selected = selected;
    this.selectEvent.emit(selected);
  }
}
